import React, { Component } from "react";
import { connect } from "react-redux";

class NotFound extends Component {
  constructor() {
    super();
  }
  
  componentDidMount() {
      this.props.history.push("/");
  } 

  render() {
    return (
        <div></div>
    );
  }
}

export default connect()(NotFound);